import { Stack } from '@mui/material';
import { Outlet } from '@remix-run/react';
import { AnonymousLayout } from '#app/components/AnonymousLayout.js';

export { ErrorBoundary } from '#app/components/AnonymousLayout.js';

export default function () {
  return (
    <AnonymousLayout>
      <Stack
        sx={{
          flex: 1,
          maxWidth: { xs: '400px' },
        }}
      >
        <Outlet />
      </Stack>
    </AnonymousLayout>
  );
}
